"use client";

import classnames from "classnames";

import styles from "./checkbox.module.scss";

export interface CheckboxProps {
  checked: boolean;
  onChange: () => void;
  size?: number;
  "aria-label"?: string;
  "data-testid"?: string;
}

export function Checkbox({
  checked,
  onChange,
  size = 36,
  "aria-label": ariaLabel,
  "data-testid": testId,
}: CheckboxProps) {
  return (
    <button
      type="button"
      className={classnames(styles.checkbox, checked && styles.checked)}
      style={{ width: size, height: size }}
      onClick={(e) => {
        e.stopPropagation();
        onChange();
      }}
      data-testid={testId}
      aria-checked={checked}
      aria-label={ariaLabel}
      role="checkbox"
    >
      {checked && (
        <svg
          viewBox="0 0 24 24"
          className={styles.checkmark}
          width={size * 0.5}
          height={size * 0.5}
        >
          <polyline
            points="4 12 10 18 20 6"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
}
